module.exports = __webpack_public_path__ + "4176f849b92ea78c029dc6dbf1247653.png";